import React, { useEffect, useState, useRef } from "react";
import "./TypewriterIntro.css";

function TypewriterIntro({ onComplete }) {
  const [displayed, setDisplayed] = useState("");
  const [phase, setPhase] = useState("typing");
  const text = "</>";
  const indexRef = useRef(0);

  useEffect(() => {
    if (phase === "typing") {
      if (indexRef.current < text.length) {
        const timeout = setTimeout(() => {
          setDisplayed(text.slice(0, indexRef.current + 1));
          indexRef.current++;
        }, 180);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => setPhase("flash"), 400);
        return () => clearTimeout(timeout);
      }
    }

    if (phase === "flash") {
      const timeout = setTimeout(() => setPhase("split"), 1200);
      return () => clearTimeout(timeout);
    }

    if (phase === "split") {
      const timeout = setTimeout(() => {
        if (onComplete) onComplete();
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [phase, displayed]);

  return (
    <div className={`intro-wrapper phase-${phase}`}>
      <div className="intro-panel intro-panel-top" />
      <div className="intro-panel intro-panel-bottom" />
      <div className="flash-overlay" />

      <div className="intro-content">
        <span className="intro-text">
          {displayed}
          {phase === "typing" && <span className="cursor" />}
        </span>
      </div>
    </div>
  );
}

export default TypewriterIntro;